import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/subscription_trigger_records',
  component: Management,
  redirect: '/subscription_trigger_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/subscription_trigger_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listSubscriptionTriggerRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/subscription_trigger_records/ListTable'),
          meta: {
            auth: Auth.listSubscriptionTriggerRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
